import api from '../../../api/analyses/activations'
import {SET_KEY_AND_VALUE_PAIR} from "./mutations";

export const loadPixelKeys = ({ commit }) => {
    api.getPixelKeys().then(res => {
        commit('SET_PIXELS_KEYS', res.data)
    })
}

export const addNewInputField = ({ commit }) => {
    commit('SET_KEY_AND_VALUE_PAIR', null)
}

export const removeInputField = ({ commit }, index) => {
    commit('REMOVE_KEY_AND_VALUE_PAIR', index)
}